/*
 * EverQuilts - quantity stepper next to Add to cart (01.10.2026)
 *
 * The product template keeps Dawn's own quantity block (hidden by
 * assets/eq-product-extras.css). This moves its <quantity-input> (the
 * [ - 1 + ] control) into .eq-qty-slot beside the Add to cart button
 * (snippets/buy-buttons.liquid). The input keeps form="product-form-...",
 * so the chosen quantity is still sent with Add to cart, and Dawn's
 * quantity rules / variant updates keep working on the same element.
 */
(function () {
  'use strict';

  function mount() {
    document.querySelectorAll('[data-eq-qty-slot]').forEach(function (slot) {
      if (slot.querySelector('quantity-input')) return;
      var scope = slot.closest('product-info') || slot.closest('section') || document;
      var qty = scope.querySelector('.product-form__quantity quantity-input');
      if (!qty) return;
      slot.appendChild(qty);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
